export default class JobAdFilterController {
  private readonly contactFormSelector = '.js-contactForm';
  private readonly filterableListSelector = '.js-filterableList';
  private readonly filterableListSelectorIndividual = '.js-filterableList-individual';
  private readonly filterItemSelector = '.js-filterItem';
  private readonly filterItemIndividualSelector = '.js-filter';
  private readonly filterElementSelector = '.js-filterElement';
  private readonly filterItemActiveClass = 'jobAdList__filterListItem--active';
  private readonly filterElementActiveClass = 'jobAd__listItem--active';
  private filterIndividualList: string[][] = [];
  private filterIndividualCounts: number[][] = [];
  private filtersSet = {};
  private filterGetFromHash = '';
  private studentLabel = '';

  constructor() {
    this.studentLabel = $('.js-filter-1').data('students');
    const $filterableList = $(this.filterableListSelector);
    const $filterableListIndividual = $(this.filterableListSelectorIndividual);
    const $contactForm = $(this.contactFormSelector);

    if ($filterableList.length) {
      this.initFilter($filterableList);
    }

    if ($filterableListIndividual.length) {
      this.initFilterIndividual($filterableListIndividual);
    }

    if ($contactForm.length) {
      this.initContact($contactForm);
    }
  }

  initFilter($filterableList: JQuery) {
    $filterableList.each((index: number, el: HTMLElement) => {
      const $currentList = $(el);

      const $currentFilterElements = $currentList.find(this.filterElementSelector);
      const $currentFilterItems = $currentList.find(this.filterItemSelector);

      $currentFilterItems.each((_index: number, _el: HTMLElement) => {
        $(_el).on('click', (ev) => {
          let $currentFilterItem = $(ev.currentTarget);
          let currentFilter = $currentFilterItem.data('filter');
          $currentFilterItems.removeClass(this.filterItemActiveClass);
          $currentFilterItem.addClass(this.filterItemActiveClass);

          // "-1" means "show all"
          if (currentFilter === -1) {
            $currentFilterElements.addClass(this.filterElementActiveClass);
          } else {
            $currentFilterElements.removeClass(this.filterElementActiveClass);
            $currentFilterElements.each(() => {
              if ($(this).data('filterelement') === currentFilter) {
                $(this).addClass(this.filterElementActiveClass);
              }
            });
          }
        });
      });
    });
  }

  initFilterIndividual($filterableList: JQuery) {
    const filterCount = $filterableList.data('filtercount');
    this.getAvailableFilters($filterableList, filterCount);
    this.setFilterOptions($filterableList, filterCount);
    this.updateFilterOptions($filterableList);
    this.addFilterItemChangeWatcher($filterableList);
    this.setFiltersFromHash($filterableList);

    $(window).on('hashchange', () => {
      this.setFiltersFromHash($filterableList);
    });
  }

  initContact($contactForm: JQuery) {
    this.setContactPreviousPageFromHash($contactForm);

    $(window).on('hashchange', () => {
      this.setContactPreviousPageFromHash($contactForm);
    });
  }

  addFilterItemChangeWatcher($filterableList: JQuery) {
    $filterableList.each((index: number, el: HTMLElement) => {
      const $currentList = $(el);
      const $currentFilterItems = $currentList.find(this.filterItemIndividualSelector);

      $currentFilterItems.each((_index: number, _el: HTMLElement) => {
        $(_el).on('change', (ev) => {
          const selectedFilter: HTMLSelectElement = <HTMLSelectElement>ev.currentTarget;
          const iFilter: string = selectedFilter.dataset.filter || '';
          this.filtersSet[iFilter] = selectedFilter.value;
          this.applyFilterIndividual($currentList);
          this.updateFilterOptions($currentList);
        });
      });
    });
  }

  getAvailableFilters($filterableList: JQuery, filterCount: number) {
    const $currentFilterElements = $filterableList.find(this.filterElementSelector);
    for (let i = 0; i < filterCount; i++) {
      this.filterIndividualList[i] = [];
    }

    // fill list of all filters
    $currentFilterElements.each((key, value) => {
      for (let filterIndex = 0; filterIndex < filterCount; filterIndex++) {
        let filterValue = $(value).data('filter-' + filterIndex);
        if (filterValue) {
          this.singeAddToList(this.filterIndividualList[filterIndex], filterValue);
        }
      }
    });

    this.singeAddToList(this.filterIndividualList[1], this.studentLabel);

    this.sortList(filterCount);

    this.filterIndividualCounts = this.filterIndividualList.map(function (x) {
      return x.map(function () {
        return 0;
      });
    });
  }

  sortList(filterCount: number) {
    for (let j = 0; j < filterCount; j++) {
      this.filterIndividualList[j].sort();
    }

    // change sorting according to ticket RAM339007-9:
    const idealSorting = [
      // DE
      'Berufseinsteiger / -erfahrene',
      'Studierende',
      'Schüler',
      // EN
      'Young Professionals/ Professionals',
      'University Students',
      'School Students',
    ];
    let items: any = this.filterIndividualList[1];
    let result: any = [];

    idealSorting.forEach(function (key: string) {
      let found = false;
      items = items.filter(function (item) {
        if (!found && item === key) {
          result.push(item);
          found = true;
          return false;
        }
        return true;
      });
    });
    this.filterIndividualList[1] = result;
  }

  singeAddToList(list, element) {
    if (list.indexOf(element) < 0) {
      list.push(element);
    }
  }

  setFilterOptions($filterableList: JQuery, filterCount: number) {
    for (let filterIndex = 0; filterIndex < filterCount; filterIndex++) {
      let currentList = '';
      for (let filterItemIndex = 0; filterItemIndex < this.filterIndividualList[filterIndex].length; filterItemIndex++) {
        currentList += ''
          + '<option'
          + ' class="js-option js-option-' + filterItemIndex + '"'
          + ' value="' + this.filterIndividualList[filterIndex][filterItemIndex] + '"'
          + '>'
          + this.filterIndividualList[filterIndex][filterItemIndex]
          + '</option>';
      }
      $filterableList.find('.js-filter-' + filterIndex).append(currentList);
    }
  }

  updateFilterOptions($filterableList: JQuery) {
    let $listContent = $filterableList.find('.js-filterElement');

    // reset counts
    for (let filterResetIndex = 0; filterResetIndex < this.filterIndividualList.length; filterResetIndex++) {
      for (let filterOptionResetIndex = 0; filterOptionResetIndex < this.filterIndividualCounts[filterResetIndex].length; filterOptionResetIndex++) {
        this.filterIndividualCounts[filterResetIndex][filterOptionResetIndex] = 0;
      }
    }

    // count results filter
    $listContent.each((index, el) => {
      const $currentRow = $(el);
      for (let filterIndex = 0; filterIndex < this.filterIndividualList.length; filterIndex++) {
        for (let filterOptionIndex = 0; filterOptionIndex < this.filterIndividualList[filterIndex].length; filterOptionIndex++) {
          if ($currentRow.data('filter-' + filterIndex) === this.filterIndividualList[filterIndex][filterOptionIndex]) {
            if (this.isRowVisible($currentRow, filterIndex)) {
              this.filterIndividualCounts[filterIndex][filterOptionIndex]++;
            }
          }
        }
      }
    });

    $filterableList.find('.js-option').prop('disabled', false).removeClass('ss-disabled');
    for (let filterIndex2 = 0; filterIndex2 < this.filterIndividualCounts.length; filterIndex2++) {
      if (filterIndex2.toString() !== this.filterGetFromHash) {
        for (let filterOptionIndex2 = 0; filterOptionIndex2 <= this.filterIndividualCounts.length; filterOptionIndex2++) {
          if (this.filterIndividualCounts[filterIndex2][filterOptionIndex2] <= 0) {

            // Todo: currently has to be left commented, because it could be reactivated somewhen. Otherwise to remove.
            //$filterableList.find('.js-filter-' + filterIndex2 + ' .js-option-' + filterOptionIndex2).prop('disabled', true).addClass('ss-disabled');
          }
        }
      }
    }
  }

  isRowVisible($currentRow: JQuery, ignoredFilterId: number) {
    let active = true;

    $.each(this.filtersSet, function (key, value) {
      if (key !== ignoredFilterId) {
        let currentValue = $currentRow.data('filter-' + key);
        if (value !== '-1' && currentValue !== value) {
          active = false;
        }
      }
    });
    return active;
  }

  applyFilterIndividual($currentList: JQuery) {
    const $listContent = $currentList.find(this.filterElementSelector);
    $listContent.addClass(this.filterElementActiveClass);
    $listContent.each((number, el) => {
      const $currentRow = $(el);

      $.each(this.filtersSet, (key, value) => {
        let currentValue = $currentRow.data('filter-' + key);
        if (value !== '-1' && currentValue !== value) {
          $currentRow.removeClass(this.filterElementActiveClass);
        }
      });
    });
    if ($('.jobAd__listItem--active').length > 0) {
      $('.js-no-vacancies').hide();
    } else {
      $('.js-no-vacancies').show();
    }
  }

  setFiltersFromHash($filterableList: JQuery) {
    let pairs: string[] = location.hash.substr(1).split('&');
    if (pairs && pairs[0]) {
      $('.js-no-vacancies .js-entryLevel').text(pairs[0].split('=')[1]);
      // "something" is animating on page load - we are fine if we queue us after that
      setTimeout(
        () => {
          $('html, body').stop().animate({scrollTop: $filterableList.offset()!.top - 200});
        },
        500,
      );

      this.removeHashFromURL();

      $.each(pairs, (key, value) => {
        let pairArray: string[] = value.split('=');
        if (pairArray[0] && pairArray[1]) {
          let valueDecoded = decodeURIComponent(pairArray[1]);
          let $filter = $filterableList.find('.js-filter-' + pairArray[0]);
          if ($filter.length && $filter.find('option[value="' + valueDecoded + '"]').length) {
            this.filterGetFromHash = pairArray[0];
            $filter.attr('value', valueDecoded).val(valueDecoded).trigger('change');
          }
        }
      });
    }
  }

  setContactPreviousPageFromHash($contactForm: JQuery) {
    let pairs = location.hash.substr(1).split('&');
    if (pairs && pairs[0]) {
      $('body').stop().animate({scrollTop: $contactForm.offset()!.top + 220});
      $('.js-contactForm-Page').val(pairs[0]);
      this.removeHashFromURL();
    }
  }

  removeHashFromURL() {
    history.pushState('', document.title, window.location.pathname + window.location.search);
  }
}
